import { Box, createStyles, makeStyles, Paper } from '@material-ui/core';
import { ExtendedTheme, MessageView, TextBlock, UserInterfaceCheck } from 'neon-design-system';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getChannelLink } from '../../../utils/link.utils';
import { EmailNeonSales } from '../../ui/EmailNeonSales';

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) =>
	createStyles({
		root: {
			height: 'calc(100vh - 212px)',
			alignItems: 'center',
			[theme.breakpoints.down('xs')]: {
				paddingTop: theme.spacing(4)
			}
		},
		paper: {
			padding: theme.spacing(2)
		},
		blueGray: {
			color: theme.themeColors.blueGrey[200]
		},
		boldFont: {
			fontWeight: theme.typography.fontWeightBold
		},
		smallCheck: {
			width: 12,
			height: 12,
			paddingTop: 5,
			paddingLeft: 5
		},
		topBox: {
			paddingBottom: 32,
			'& p:not(:last-child)': {
				marginBottom: 32
			}
		}
	})
);

const PremiumChannelSubscribeNoClearingAccountConfirm = () => {
	const classes = useStyles();
	const history = useHistory();
	const { channelId } = useParams<{ channelId: string }>();

	return (
		<Box display="flex" className={classes.root}>
			<MessageView styleName="primary" title={'Request your free trial'}
				primaryAction={{
					label: 'Back to channel',
					onClick: () => history.push(getChannelLink(channelId)),
					styleName: 'primary'
				}}>
				<Box mt={2} className={classes.topBox} >
					<TextBlock styleName="body" color="grey" ink="muted" >
						Currently, in-app channel subscriptions are only available to Marex Clearing clients.
					</TextBlock>
					<TextBlock styleName="body" color="grey" ink="muted" >
						You can register your interest for a free trial to this Channel and we will contact
						you to discuss pricing and alternative payment options.
					</TextBlock>
				</Box>
				<Paper classes={{ root: classes.paper }} >
					<Box display="flex" >
						<UserInterfaceCheck size="small" className={classes.smallCheck} />
						<TextBlock styleName="footnote" className={classes.boldFont}>
							Thank you for registering your interest. A member of the
							Neon team will be in touch soon. If you need further assistance,
							you can email us at &nbsp;
							<EmailNeonSales />
						</TextBlock>
					</Box>
				</Paper>
			</MessageView>
		</Box>
	);
};

export default PremiumChannelSubscribeNoClearingAccountConfirm;
